export const OPEN_MODAL = 'OPEN_MODAL';

export const openModal = assetID => {
    return {
        type: OPEN_MODAL,
        assetID,
    };
};

export const CLOSE_MODAL = 'CLOSE_MODAL';

export const closeModal = () => {
    return {
        type: CLOSE_MODAL,
    };
};

export const SET_FORM = 'SET_FORM';

export const setForm = (
    name,
    isTriggerExternal = false,
    url,
    title,
    endDate
) => {
    return (dispatch, getState) => {
        if (getState().modal.form === name) {
            return null;
        }

        dispatch({
            type: SET_FORM,
            name,
            isTriggerExternal,
            url,
            title,
            endDate,
        });
    };
};



// WEBPACK FOOTER //
// ./src/actions/modal.js